import { render, staticRenderFns } from "./ArtificialReturnDrawer.vue?vue&type=template&id=7addf135&scoped=true&"
import script from "./ArtificialReturnDrawer.vue?vue&type=script&lang=js&"
export * from "./ArtificialReturnDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ArtificialReturnDrawer.vue?vue&type=style&index=0&id=7addf135&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7addf135",
  null
  
)

export default component.exports